<template>
    <div class="sap-bom-root">

        <!-- HEADER -->
        <div class="sap-header sap-card">
            <div class="sap-header-inner">
                <div class="sap-header-left">
                    <h1 class="sap-title">Gestión Masiva de Listas de Inductores</h1>
                </div>
                <div class="sap-header-actions">
                    <button class="btn-primary" @click="abrirCatalogo">Catálogo de Artículos</button>
                    <!-- <button class="btn-secondary" @click="resetDatos">Reset Datos Ejemplo</button> -->
                </div>
            </div>
        </div>

        <!-- MAIN (contiene banner + pasos) -->
        <div class="sap-main">

            <!-- PASO 1 + PASO 2 -->
            <div class="grid-12">

                <!-- PASO 1 -->
                <div class="sap-col-5 sap-card">
                    <div class="step-header">
                        <span class="step-badge">1</span>
                        <h2 class="step-title">Lista de Materiales</h2>
                    </div>

                    <div class="field-group relative">
                        <label class="field-label">Buscar Lista de Materiales</label>
                        <div style="position: relative; display: flex; align-items: center; width: 100%;">
                            <input v-model="busquedaQuery" type="text" class="field-input"
                                :disabled="!!articuloSeleccionado" placeholder="Ej: F01101 o Mango Kent..."
                                @input="filtrarMateriales" @focus="mostrarDropdown" @blur="scheduleOcultarDropdown"
                                style="padding-right: 75px;" />
                            <button v-if="articuloSeleccionado" type="button" class="btn-clear-input"
                                @click="limpiarSeleccion">Limpiar</button>
                        </div>
                        <div v-if="dropdownVisible && sugerencias.length" class="autocomplete-dropdown">
                            <div v-for="art in sugerencias" :key="art.code" class="autocomplete-item"
                                @mousedown.prevent="seleccionarMaterial(art.code)">
                                <div class="ac-row">
                                    <span class="ac-code">{{ art.code }}</span>
                                </div>
                                <p class="ac-desc">{{ art.desc }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="field-group">
                        <label class="field-label">Descripción de Lista de Materiales</label>
                        <input type="text" :value="articuloSeleccionado ? articuloSeleccionado.desc : ''" readonly
                            class="field-input field-readonly" placeholder="Se completa al seleccionar..." />
                    </div>
                </div>

                <!-- PASO 2 -->
                <div class="sap-col-7 sap-card">
                    <div class="step-header">
                        <span class="step-badge">2</span>
                        <h2 class="step-title">Parámetros de Cantidad</h2>
                    </div>

                    <div class="params-grid">
                        <div class="field-group">
                            <label class="field-label">
                                Cant. LMat
                                <span class="label-um">
                                    ({{ articuloSeleccionado ? articuloSeleccionado.um : 'und' }})
                                </span>
                            </label>
                            <input v-model="cantLmat" type="number" min="0" step="0.000001"
                                class="field-input text-right mono" @input="actualizarNuevasCants"
                                @blur="cantLmat = formatTo6Decimals(cantLmat); actualizarNuevasCants()" />
                            <p class="field-hint">Consumo en LMat</p>
                        </div>
                        <div class="field-group">
                            <label class="field-label">Art. por Unid. Compra</label>
                            <input v-model="artPorUnidCompra" type="number" min="0" step="0.000001"
                                class="field-input text-right mono" @input="actualizarNuevasCants"
                                @blur="artPorUnidCompra = formatTo6Decimals(artPorUnidCompra); actualizarNuevasCants()" />
                            <p class="field-hint">ItemsPerPurchaseUnit</p>
                        </div>
                        <div class="field-group">
                            <label class="field-label">Cant. por Paquete</label>
                            <input v-model="cantPorPaquete" type="number" min="0" step="0.000001"
                                class="field-input text-right mono" @input="actualizarNuevasCants"
                                @blur="cantPorPaquete = formatTo6Decimals(cantPorPaquete); actualizarNuevasCants()" />
                            <p class="field-hint">PurchaseQtyPerPackUnit</p>
                        </div>
                    </div>

                    <div class="info-box">
                        <p class="info-text"><strong>Sincronización SAP:</strong> Los valores <em>Art. por Unid.
                                Compra</em> y <em>Cant. por Paquete</em> se actualizarán en la entidad
                            <strong>Items</strong> del artículo seleccionado. La <em>Cant. LMat</em> se actualizará en
                            cada <strong>ProductTree</strong> de los productos padre seleccionados.
                        </p>
                    </div>
                </div>
            </div>


            <!-- PASO 3 -->
            <div class="sap-card">
                <div class="paso3-header">
                    <div class="step-header">
                        <span class="step-badge">3</span>
                        <h2 class="step-title">Inductores de la Lista de Materiales</h2>
                    </div>
                </div>

                <div class="tabla-filtros-bar"
                    style="margin-bottom: 12px; display: flex; gap: 8px; justify-content: space-between;">
                    <input v-model="busquedaPadres" type="text" class="field-input"
                        placeholder="Buscar por código o descripción en inductores..."
                        style="max-width: 300px;" />

                    <button class="btn-outline" @click="agregarPadre">Agregar Inductor</button>
                </div>

                <div class="table-wrapper">
                    <table class="sap-table xs">
                        <thead>
                            <tr class="table-head">
                                <th class="th-check"><input type="checkbox" v-model="checkAll" @change="toggleTodos" />
                                </th>
                                <th class="th-left">Código Inductor</th>
                                <th class="th-left">Descripción</th>
                                <th class="th-center">UM</th>
                                <th class="th-left">Grupo Inductor</th>
                                <th class="th-right">Cant. LMat</th>
                                <th class="th-right">Art. por Unid. Compra</th>
                                <th class="th-right">Cant. por Paquete</th>
                                <th class="th-center">Estado</th>
                                <th class="th-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!padresFiltrados.length">
                                <td colspan="10" class="td-empty">Seleccione una lista de materiales para ver sus inductores
                                </td>
                            </tr>
                            <tr v-for="p in padresPaginados" :key="p.code"
                                :class="['table-row', p.seleccionado ? 'row-selected' : '', p.code === filaActivaCode ? 'row-active' : '']"
                                @click="seleccionarFila(p)" style="cursor: pointer;">
                                <td class="td-check" @click.stop>
                                    <input type="checkbox" v-model="p.seleccionado" @change="onToggleFila" />
                                </td>
                                <td class="td-mono">{{ p.code }}</td>
                                <td class="td-text">{{ p.desc }}</td>
                                <td class="td-center gray">{{ p.um || 'UND' }}</td>
                                <td class="td-text gray-sm">{{ p.grupoInductor || 'Insumo' }}</td>
                                <td class="td-center">
                                    <input type="number" v-model="p.nuevaCant" min="0" step="0.000001"
                                        class="field-input text-right mono"
                                        style="width: 100px; padding: 4px 8px; font-size: 11px; margin: 0 auto; display: block;"
                                        @click.stop @input="actualizarFilaInput(p)"
                                        @blur="p.nuevaCant = formatTo6Decimals(p.nuevaCant); actualizarFilaInput(p)" />
                                </td>
                                <td class="td-center">
                                    <input type="number" v-model="p.artPorUnidCompra" min="0" step="0.000001"
                                        class="field-input text-right mono"
                                        style="width: 100px; padding: 4px 8px; font-size: 11px; margin: 0 auto; display: block;"
                                        @click.stop @input="actualizarFilaInput(p)"
                                        @blur="p.artPorUnidCompra = formatTo6Decimals(p.artPorUnidCompra); actualizarFilaInput(p)" />
                                </td>
                                <td class="td-center">
                                    <input type="number" v-model="p.cantPorPaquete" min="0" step="0.000001"
                                        class="field-input text-right mono blue-bold"
                                        style="width: 100px; padding: 4px 8px; font-size: 11px; margin: 0 auto; display: block;"
                                        @click.stop @input="actualizarFilaInput(p)"
                                        @blur="p.cantPorPaquete = formatTo6Decimals(p.cantPorPaquete); actualizarFilaInput(p)" />
                                </td>
                                <td class="td-center">
                                    <span v-if="p.estado === 'Existe'" class="badge-green">Existe</span>
                                    <span v-else class="badge-blue">Nuevo</span>
                                </td>
                                <td class="td-center" @click.stop>
                                    <button class="btn-delete" @click="eliminarFila(p)"
                                        title="Eliminar">&#x2715;</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="padresFiltrados.length > 0" class="paginator-bar"
                    style="display: flex; justify-content: space-between; align-items: center; padding: 12px 0 0; font-size: 13px; color: #64748b;">
                    <div>
                        Mostrando {{ (paginaActual - 1) * itemsPorPagina + 1 }} a {{ Math.min(paginaActual *
                            itemsPorPagina, padresFiltrados.length) }} de {{ padresFiltrados.length }} registros
                    </div>
                    <div class="paginator-buttons" style="display: flex; gap: 6px;">
                        <button class="btn-sm-ghost" :disabled="paginaActual === 1"
                            @click="paginaActual--">Anterior</button>
                        <button class="btn-sm-ghost" :disabled="paginaActual >= totalPaginas"
                            @click="paginaActual++">Siguiente</button>
                    </div>
                </div>

                <div class="apply-bar">
                    <button class="btn-apply" @click="aplicarCambios">Aplicar Cambios Masivos en SAP B1</button>
                </div>
            </div>

        </div><!-- /sap-main -->

        <!-- MODAL CATÁLOGO -->
        <div v-if="modalCatalogo" class="modal-overlay" @click.self="cerrarCatalogo">
            <div class="modal-box modal-xl">
                <div class="modal-header-white">
                    <div>
                        <h3 class="modal-title-dark">Catálogo de Listas de Materiales</h3>
                        <p class="modal-subtitle-dark">Seleccione el insumo a gestionar</p>
                    </div>
                    <button class="modal-close-dark" @click="cerrarCatalogo">&times;</button>
                </div>
                <div class="modal-search-bar" style="display: flex; gap: 12px; align-items: center; position: relative;">
                    <input v-model="busquedaCatalogo" type="text" class="field-input"
                        placeholder="Buscar por código, descripción o grupo..." style="flex: 1;" />
                    
                    <div class="field-group relative" style="margin: 0; width: 280px; display: flex; align-items: center;">
                        <input v-model="busquedaGrupoCatalogo" type="text" class="field-input"
                            placeholder="Filtrar por grupo..." @input="filtrarGruposCatalogo"
                            @focus="mostrarDropdownGrupo" @blur="scheduleOcultarDropdownGrupo"
                            style="padding-right: 35px;" />
                        <button v-if="grupoCatalogoSeleccionado" type="button" class="btn-clear-input"
                            @click="limpiarSeleccionGrupo" style="right: 8px; background: none; border: none; font-size: 16px; cursor: pointer; color: #94a3b8; position: absolute;">&times;</button>
                        
                        <div v-if="dropdownGrupoVisible && sugerenciasGrupos.length" class="autocomplete-dropdown" style="z-index: 1000; width: 100%; top: 34px;">
                            <div v-for="g in sugerenciasGrupos" :key="g.cod" class="autocomplete-item"
                                @mousedown.prevent="seleccionarGrupoCatalogo(g)">
                                <div class="ac-row">
                                    <span class="ac-code">{{ g.cod }}</span>
                                </div>
                                <p class="ac-desc" style="margin: 0; font-size: 11px;">{{ g.nam }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-scroll">
                    <table class="sap-table xs">
                        <thead class="sticky-head">
                            <tr>
                                <th class="th-left">Código</th>
                                <th class="th-left">Descripción</th>
                                <th class="th-left">Grupo</th>
                                <th class="th-center">UM</th>
                                <th class="th-right">Stock</th>
                                <th class="th-right">Precio Base</th>
                                <th class="th-center">LMat</th>
                                <th class="th-center">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="art in catalogoPaginado" :key="art.code" class="table-row-hover">
                                <td class="td-mono">{{ art.code }}</td>
                                <td class="td-text">{{ art.desc }}</td>
                                <td class="td-text gray">{{ art.grupo }}</td>
                                <td class="td-center gray">{{ art.um }}</td>
                                <td class="td-right">{{ art.stock.toLocaleString("es-PE") }}</td>
                                <td class="td-right">S/ {{ art.precio.toFixed(2) }}</td>
                                <td class="td-center">
                                    <span v-if="art.lmat" class="badge-green-sm">Sí</span>
                                    <span v-else class="badge-gray-sm">No</span>
                                </td>
                                <td class="td-center">
                                    <button class="btn-primary-sm" @click="seleccionarInsumo(art.code)">Seleccionar
                                        Insumo</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="catalogoFiltrado.length > 0" class="paginator-bar"
                    style="display: flex; justify-content: space-between; align-items: center; padding: 16px 20px; border-top: 1px solid #f1f5f9; font-size: 13px; color: #64748b;">
                    <div>
                        Mostrando {{ (paginaCatalogo - 1) * itemsPorPaginaCatalogo + 1 }} a {{ Math.min(paginaCatalogo *
                            itemsPorPaginaCatalogo, catalogoFiltrado.length) }} de {{ catalogoFiltrado.length }} registros
                    </div>
                    <div class="paginator-buttons" style="display: flex; gap: 6px;">
                        <button class="btn-sm-ghost" :disabled="paginaCatalogo === 1"
                            @click="paginaCatalogo--">Anterior</button>
                        <button class="btn-sm-ghost" :disabled="paginaCatalogo >= totalPaginasCatalogo"
                            @click="paginaCatalogo++">Siguiente</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL BOM -->
        <div v-if="modalBom" class="modal-overlay" @click.self="cerrarBom">
            <div class="modal-box modal-lg">
                <div class="modal-header-blue">
                    <div>
                        <h3 class="modal-title-white">Lista de Materiales</h3>
                        <p class="modal-subtitle-blue">{{ bomData ? bomData.code + ' - ' + bomData.desc : bomCode }}</p>
                    </div>
                    <button class="modal-close-white" @click="cerrarBom">&times;</button>
                </div>
                <div class="bom-info-bar">
                    <template v-if="bomData">
                        <div class="bom-info-item">
                            <p class="bom-info-label">Código</p>
                            <p class="bom-info-value">{{ bomData.code }}</p>
                        </div>
                        <div class="bom-info-item">
                            <p class="bom-info-label">Tipo LMat</p>
                            <p class="bom-info-value">Fabricación</p>
                        </div>
                        <div class="bom-info-item">
                            <p class="bom-info-label">Cant. Base</p>
                            <p class="bom-info-value">1.00</p>
                        </div>
                        <div class="bom-info-item">
                            <p class="bom-info-label">Estado</p>
                            <p :class="bomData.lmat ? 'bom-status-ok' : 'bom-status-new'">{{ bomData.lmat ? 'Activa' :
                                'Nueva' }}</p>
                        </div>
                    </template>
                    <template v-else>
                        <p class="gray text-sm">Artículo {{ bomCode }} no encontrado en la base de datos local.</p>
                    </template>
                </div>
                <div class="modal-scroll p-md">
                    <table class="sap-table xs">
                        <thead>
                            <tr class="bom-thead">
                                <th class="th-left">Código Item</th>
                                <th class="th-left">Descripción</th>
                                <th class="th-center">Tipo</th>
                                <th class="th-right">Cantidad</th>
                                <th class="th-center">UM</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="bomData && bomData.lmat && bomData.lmat.length">
                                <tr v-for="(c, ci) in bomData.lmat" :key="ci" class="table-row-hover">
                                    <td class="td-mono">{{ c.code }}</td>
                                    <td class="td-text">{{ c.desc }}</td>
                                    <td class="td-center"><span class="badge-tipo">{{ c.tipo }}</span></td>
                                    <td class="td-right mono-sm">{{ formatTo6Decimals(c.cant) }}</td>
                                    <td class="td-center gray">{{ c.um }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="5" class="td-empty">No hay LMat registrada. Se creará una nueva al aplicar
                                    cambios.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer-light">
                    <span v-if="bomData && bomData.lmat">Total insumos: {{ bomData.lmat.length }}</span>
                    <span v-else>Se creará nueva Lista de Materiales al aplicar cambios en SAP B1.</span>
                </div>
            </div>
        </div>

        <!-- MODAL LOGS -->
        <div v-if="modalLogs" class="modal-overlay" @click.self="cerrarLogs">
            <div class="modal-box modal-lg modal-dark">
                <div class="modal-header-dark">
                    <h3 class="modal-title-green">Consola de Logs - Operaciones REST SAP B1</h3>
                    <button class="modal-close-gray" @click="cerrarLogs">&times;</button>
                </div>
                <div class="consola-logs" v-html="logsHtml"></div>
                <div class="modal-footer-dark">
                    <button class="btn-gray" @click="cerrarLogs">Cerrar Consola</button>
                </div>
            </div>
        </div>

        <!-- MODAL AGREGAR PADRE -->
        <div v-if="modalAgregarPadre" class="modal-overlay" @click.self="cerrarAgregarPadre">
            <div class="modal-box modal-md">
                <div class="modal-header-white">
                    <h3 class="modal-title-dark">Agregar Inductor</h3>
                    <button class="modal-close-gray" @click="cerrarAgregarPadre">&times;</button>
                </div>
                <div class="p-md">
                    <div class="field-group">
                        <label class="field-label">Código del Inductor</label>
                        <input v-model="nuevoPadreCode" type="text"
                            :class="['field-input', erroresNuevoPadre.code ? 'input-error' : '']"
                            placeholder="Ej: I01101" @keyup.enter="guardarNuevoPadre" />
                        <p v-if="erroresNuevoPadre.code" class="field-error-msg">{{ erroresNuevoPadre.code }}</p>
                    </div>
                    <div class="field-group" style="margin-bottom: 0;">
                        <label class="field-label">Descripción</label>
                        <input v-model="nuevoPadreDesc" type="text"
                            :class="['field-input', erroresNuevoPadre.desc ? 'input-error' : '']"
                            placeholder="Ej: Insumo mango kent" @keyup.enter="guardarNuevoPadre" />
                        <p v-if="erroresNuevoPadre.desc" class="field-error-msg">{{ erroresNuevoPadre.desc }}</p>
                    </div>
                </div>
                <div class="modal-footer-white">
                    <button class="btn-secondary" @click="cerrarAgregarPadre">Cancelar</button>
                    <button class="btn-primary" @click="guardarNuevoPadre">Agregar Inductor</button>
                </div>
            </div>
        </div>

    </div><!-- /sap-bom-root -->
</template>

<script>
import inductoresData from "./Inductores.json";
import articulosData from "./Articulos.json";
import listaMaterialesData from "./ListaMateriales.json";

const STORAGE_KEY = "SAP_LMAT_APP_STATE_V2.5";

const articulosMasterDB = inductoresData.map(item => ({
    code: item.CodigoInductor || "",
    desc: item.NombreInductor || "Sin descripción",
    grupo: "Inductores",
    um: item.UnidadMedida || "UND",
    stock: 0,
    precio: 0,
    numInBuy: 1,
    purPackUn: 1,
    cantLMatDefecto: 0,
    lmat: null,
    padresAfectados: [],
    ArticulosRelacionadosJSON: item.ArticulosRelacionadosJSON || "[]"
}));

const articulosMasterDBList = listaMaterialesData.map(item => {
    let grupo = "General";
    let grupoCod = null;
    if (item.InductoresJSON) {
        try {
            const inductores = JSON.parse(item.InductoresJSON);
            if (Array.isArray(inductores) && inductores.length > 0) {
                grupo = inductores[0].ItmsGrpNam || "General";
                grupoCod = inductores[0].ItmsGrpCod || null;
            }
        } catch (e) {
            // ignore
        }
    }
    return {
        code: item.Code || "",
        desc: item.Name || "Sin descripción",
        grupo: grupo,
        grupoCod: grupoCod,
        um: "UND",
        stock: 0,
        precio: 0,
        lmat: !!item.InductoresJSON
    };
});

export default {
    name: "Inductors",
    data() {
        return {
            // Materiales
            listasMateriales: listaMaterialesData,
            // Autocomplete
            busquedaQuery: "",
            sugerencias: [],
            dropdownVisible: false,
            // Artículo seleccionado
            articuloSeleccionado: null,
            // Parámetros
            cantLmat: "0.000000",
            artPorUnidCompra: "0.000000",
            cantPorPaquete: "0.000000",
            errores: {
                cantLmat: "",
                artPorUnidCompra: "",
                cantPorPaquete: ""
            },
            // Tabla padres
            padresEnTabla: [],
            checkAll: false,
            filaActivaCode: "",
            // Modales
            modalCatalogo: false,
            busquedaCatalogo: "",
            busquedaGrupoCatalogo: "",
            grupoCatalogoSeleccionado: null,
            sugerenciasGrupos: [],
            dropdownGrupoVisible: false,

            modalBom: false,
            bomCode: "",
            bomData: null,
            modalLogs: false,
            logsHtml: "",
            // Modal Agregar Padre
            modalAgregarPadre: false,
            nuevoPadreCode: "",
            nuevoPadreDesc: "",
            erroresNuevoPadre: {
                code: "",
                desc: ""
            },
            // Paginador y buscador de padres afectados
            busquedaPadres: "",
            grupoSeleccionado: "",
            paginaActual: 1,
            itemsPorPagina: 10,
            // Paginador para catálogo
            paginaCatalogo: 1,
            itemsPorPaginaCatalogo: 10
        };
    },
    mounted() {
        this.inicializar();
    },
    watch: {
        cantLmat() { this.guardarEstado(); },
        artPorUnidCompra() { this.guardarEstado(); },
        cantPorPaquete() { this.guardarEstado(); },
        padresEnTabla: { deep: true, handler() { this.guardarEstado(); } },
        busquedaPadres() { this.paginaActual = 1; },
        grupoSeleccionado() { this.paginaActual = 1; },
        busquedaCatalogo() { this.paginaCatalogo = 1; },
        busquedaGrupoCatalogo() { this.paginaCatalogo = 1; }
    },
    computed: {
        gruposInductores() {
            const map = new Map();
            if (this.listasMateriales && Array.isArray(this.listasMateriales)) {
                this.listasMateriales.forEach(m => {
                    if (m.InductoresJSON) {
                        try {
                            const parsed = JSON.parse(m.InductoresJSON);
                            if (Array.isArray(parsed)) {
                                parsed.forEach(ind => {
                                    if (ind && ind.ItmsGrpCod !== undefined && ind.ItmsGrpCod !== null) {
                                        const cod = ind.ItmsGrpCod;
                                        const nam = ind.ItmsGrpNam || `Grupo ${cod}`;
                                        map.set(cod, { cod, nam });
                                    }
                                });
                            }
                        } catch (e) {
                            // ignore parsing error
                        }
                    }
                });
            }
            return Array.from(map.values()).sort((a, b) => a.nam.localeCompare(b.nam));
        },
        padresFiltrados() {
            const q = this.busquedaPadres.trim().toLowerCase();
            if (!q) return this.padresEnTabla;
            return this.padresEnTabla.filter(p =>
                p.code.toLowerCase().includes(q) || p.desc.toLowerCase().includes(q)
            );
        },
        totalPaginas() {
            return Math.ceil(this.padresFiltrados.length / this.itemsPorPagina) || 1;
        },
        padresPaginados() {
            const start = (this.paginaActual - 1) * this.itemsPorPagina;
            const end = start + this.itemsPorPagina;
            return this.padresFiltrados.slice(start, end);
        },
        catalogoPaginado() {
            const start = (this.paginaCatalogo - 1) * this.itemsPorPaginaCatalogo;
            const end = start + this.itemsPorPaginaCatalogo;
            return this.catalogoFiltrado.slice(start, end);
        },
        totalPaginasCatalogo() {
            return Math.ceil(this.catalogoFiltrado.length / this.itemsPorPaginaCatalogo) || 1;
        },
        catalogoFiltrado() {
            let res = articulosMasterDBList;
            if (this.grupoCatalogoSeleccionado) {
                const targetCod = this.grupoCatalogoSeleccionado.cod;
                res = res.filter(a => {
                    if (a.grupoCod === targetCod || String(a.grupoCod) === String(targetCod)) {
                        return true;
                    }
                    const origMat = this.listasMateriales.find(m => m.Code === a.code);
                    if (origMat && origMat.InductoresJSON) {
                        try {
                            const inductores = JSON.parse(origMat.InductoresJSON);
                            if (Array.isArray(inductores)) {
                                return inductores.some(ind => ind && (ind.ItmsGrpCod === targetCod || String(ind.ItmsGrpCod) === String(targetCod)));
                            }
                        } catch (e) {}
                    }
                    return false;
                });
            }
            const q = this.busquedaCatalogo.trim().toLowerCase();
            if (q) {
                res = res.filter(a =>
                    a.code.toLowerCase().includes(q) ||
                    a.desc.toLowerCase().includes(q) ||
                    (a.grupo && a.grupo.toLowerCase().includes(q))
                );
            }
            return res;
        }
    },
    methods: {
        formatTo6Decimals(val) {
            if (val === undefined || val === null || val === "") return "";
            const num = Number(val);
            return isNaN(num) ? "" : num.toFixed(6);
        },
        // ===== INIT =====
        inicializar() {
            const guardado = localStorage.getItem(STORAGE_KEY);
            if (guardado) {
                try {
                    const s = JSON.parse(guardado);
                    this.busquedaQuery = s.busquedaQuery || "";
                    if (s.articuloSeleccionado) {
                        this.articuloSeleccionado = s.articuloSeleccionado;
                    }
                    this.cantLmat = (s.cantLmat !== undefined && s.cantLmat !== null) ? this.formatTo6Decimals(s.cantLmat) : "0.000000";
                    this.artPorUnidCompra = (s.artPorUnidCompra !== undefined && s.artPorUnidCompra !== null) ? this.formatTo6Decimals(s.artPorUnidCompra) : "0.000000";
                    this.cantPorPaquete = (s.cantPorPaquete !== undefined && s.cantPorPaquete !== null) ? this.formatTo6Decimals(s.cantPorPaquete) : "0.000000";
                    this.filaActivaCode = s.filaActivaCode || "";
                    if (s.padresEnTabla && s.padresEnTabla.length) {
                        this.padresEnTabla = s.padresEnTabla.map(p => {
                            const cantActual = (p.cantActual !== undefined && p.cantActual !== null) ? this.formatTo6Decimals(p.cantActual) : "0.000000";
                            return {
                                ...p,
                                cantActual: cantActual,
                                nuevaCant: (p.nuevaCant !== undefined && p.nuevaCant !== null) ? this.formatTo6Decimals(p.nuevaCant) : cantActual,
                                artPorUnidCompra: (p.artPorUnidCompra !== undefined && p.artPorUnidCompra !== null) ? this.formatTo6Decimals(p.artPorUnidCompra) : "1.000000",
                                cantPorPaquete: (p.cantPorPaquete !== undefined && p.cantPorPaquete !== null) ? this.formatTo6Decimals(p.cantPorPaquete) : "1.000000"
                            };
                        });
                    }
                    if (this.filaActivaCode) {
                        const activeRow = this.padresEnTabla.find(p => p.code === this.filaActivaCode);
                        if (activeRow) {
                            this.cantLmat = this.formatTo6Decimals(activeRow.nuevaCant);
                            this.artPorUnidCompra = this.formatTo6Decimals(activeRow.artPorUnidCompra);
                            this.cantPorPaquete = this.formatTo6Decimals(activeRow.cantPorPaquete);
                        }
                    }
                } catch (e) { console.error("Error cargando estado:", e); }
            }
        },
        guardarEstado() {
            const estado = {
                articuloSeleccionado: this.articuloSeleccionado,
                cantLmat: this.cantLmat,
                artPorUnidCompra: this.artPorUnidCompra,
                cantPorPaquete: this.cantPorPaquete,
                padresEnTabla: this.padresEnTabla,
                filaActivaCode: this.filaActivaCode,
                busquedaQuery: this.busquedaQuery
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(estado));
        },
        resetDatos() {
            if (!confirm("¿Reiniciar todos los datos al ejemplo por defecto?")) return;
            localStorage.removeItem(STORAGE_KEY);
            location.reload();
        },
        limpiarSeleccion() {
            this.articuloSeleccionado = null;
            this.busquedaQuery = "";
            this.cantLmat = "0.000000";
            this.artPorUnidCompra = "0.000000";
            this.cantPorPaquete = "0.000000";
            this.padresEnTabla = [];
            this.filaActivaCode = "";
            this.guardarEstado();
        },
        filtrarMateriales() {
            const q = this.busquedaQuery.trim().toLowerCase();
            if (!q) {
                this.sugerencias = this.listasMateriales.map(m => ({
                    code: m.Code,
                    desc: m.Name
                }));
                this.dropdownVisible = true;
                return;
            }
            const filtered = this.listasMateriales.filter(m =>
                (m.Code && m.Code.toLowerCase().includes(q)) ||
                (m.Name && m.Name.toLowerCase().includes(q))
            );
            this.sugerencias = filtered.map(m => ({
                code: m.Code,
                desc: m.Name
            }));
            this.dropdownVisible = this.sugerencias.length > 0;
        },
        mostrarDropdown() {
            this.filtrarMateriales();
        },
        scheduleOcultarDropdown() {
            setTimeout(() => { this.dropdownVisible = false; }, 200);
        },
        seleccionarMaterial(code) {
            const mat = this.listasMateriales.find(m => m.Code === code);
            if (mat) {
                this.articuloSeleccionado = {
                    code: mat.Code,
                    desc: mat.Name,
                    um: "UND"
                };
                this.busquedaQuery = mat.Code;
                this.dropdownVisible = false;
                
                let inductores = [];
                if (mat.InductoresJSON) {
                    try {
                        let rawStr = mat.InductoresJSON.trim();
                        inductores = JSON.parse(rawStr);
                    } catch (e) {
                        console.error("Error al parsear InductoresJSON:", e);
                    }
                }

                if (inductores && inductores.length > 0) {
                    this.padresEnTabla = inductores.map(ind => ({
                        code: ind.Code,
                        desc: ind.ItemName || ind.DescripcionArt || "Sin descripción",
                        um: ind.BuyUnitMsr || "UND",
                        grupoInductor: ind.ItmsGrpNam || "Insumo",
                        cantActual: this.formatTo6Decimals(ind.Quantity !== undefined && ind.Quantity !== null ? ind.Quantity : 0),
                        nuevaCant: this.formatTo6Decimals(ind.Quantity !== undefined && ind.Quantity !== null ? ind.Quantity : 0),
                        artPorUnidCompra: this.formatTo6Decimals(ind.ArticulosXUNDCompra !== undefined && ind.ArticulosXUNDCompra !== null ? ind.ArticulosXUNDCompra : 1),
                        cantPorPaquete: this.formatTo6Decimals(ind.CantidadXPaquete !== undefined && ind.CantidadXPaquete !== null ? ind.CantidadXPaquete : 1),
                        estado: "Existe",
                        seleccionado: true
                    }));
                } else {
                    this.padresEnTabla = [];
                }
                
                this.cantLmat = "0.000000";
                this.artPorUnidCompra = "0.000000";
                this.cantPorPaquete = "0.000000";
                this.filaActivaCode = "";
                
                this.guardarEstado();
            }
        },
        seleccionarFila(p) {
            this.filaActivaCode = p.code;
            this.cantLmat = (p.nuevaCant !== undefined && p.nuevaCant !== null) ? this.formatTo6Decimals(p.nuevaCant) : "0.000000";
            this.artPorUnidCompra = (p.artPorUnidCompra !== undefined && p.artPorUnidCompra !== null) ? this.formatTo6Decimals(p.artPorUnidCompra) : "0.000000";
            this.cantPorPaquete = (p.cantPorPaquete !== undefined && p.cantPorPaquete !== null) ? this.formatTo6Decimals(p.cantPorPaquete) : "0.000000";
            this.guardarEstado();
        },
        actualizarFilaInput(p) {
            this.filaActivaCode = p.code;
            this.cantLmat = (p.nuevaCant !== undefined && p.nuevaCant !== null) ? p.nuevaCant : "0.000000";
            this.artPorUnidCompra = (p.artPorUnidCompra !== undefined && p.artPorUnidCompra !== null) ? p.artPorUnidCompra : "0.000000";
            this.cantPorPaquete = (p.cantPorPaquete !== undefined && p.cantPorPaquete !== null) ? p.cantPorPaquete : "0.000000";
            this.guardarEstado();
        },
        // ===== TABLA PADRES =====
        validarCampos() {
            let valid = true;
            this.errores = { cantLmat: "", artPorUnidCompra: "", cantPorPaquete: "" };

            if (!this.articuloSeleccionado) {
                return false;
            }

            const valCant = Number(this.cantLmat);
            if (this.cantLmat === "" || this.cantLmat === null || isNaN(valCant) || valCant < 0) {
                this.errores.cantLmat = "Debe ser un número mayor o igual a 0";
                valid = false;
            }

            const valArt = Number(this.artPorUnidCompra);
            if (this.artPorUnidCompra === "" || this.artPorUnidCompra === null || isNaN(valArt) || valArt < 0) {
                this.errores.artPorUnidCompra = "Debe ser un número mayor o igual a 0";
                valid = false;
            }

            const valPaq = Number(this.cantPorPaquete);
            if (this.cantPorPaquete === "" || this.cantPorPaquete === null || isNaN(valPaq) || valPaq < 0) {
                this.errores.cantPorPaquete = "Debe ser un número mayor o igual a 0";
                valid = false;
            }

            return valid;
        },
        actualizarNuevasCants() {
            this.validarCampos();
            if (this.filaActivaCode) {
                const fila = this.padresEnTabla.find(p => p.code === this.filaActivaCode);
                if (fila) {
                    fila.nuevaCant = this.cantLmat;
                    fila.artPorUnidCompra = this.artPorUnidCompra;
                    fila.cantPorPaquete = this.cantPorPaquete;
                }
            }
            this.guardarEstado();
        },
        onToggleFila() {
            this.checkAll = this.padresFiltrados.length > 0 && this.padresFiltrados.every(p => p.seleccionado);
            this.guardarEstado();
        },
        toggleTodos() {
            this.padresFiltrados.forEach(p => { p.seleccionado = this.checkAll; });
            this.guardarEstado();
        },
        eliminarFila(p) {
            if (!confirm("¿Eliminar este inductor?")) return;
            const idx = this.padresEnTabla.findIndex(item => item.code === p.code);
            if (idx !== -1) {
                this.padresEnTabla.splice(idx, 1);
                this.guardarEstado();
            }
        },
        agregarPadre() {
            if (!this.articuloSeleccionado) {
                this.$fun.alert("Debe seleccionar una lista de materiales en el Paso 1 antes de agregar.", "warning");
                return;
            }
            if (!this.validarCampos()) {
                this.$fun.alert("Por favor, corrija los errores en los parámetros de cantidad (Paso 2) antes de agregar.", "warning");
                return;
            }
            this.nuevoPadreCode = "";
            this.nuevoPadreDesc = "";
            this.erroresNuevoPadre = { code: "", desc: "" };
            this.modalAgregarPadre = true;
        },
        cerrarAgregarPadre() {
            this.modalAgregarPadre = false;
        },
        guardarNuevoPadre() {
            this.erroresNuevoPadre = { code: "", desc: "" };
            let valid = true;

            const code = this.nuevoPadreCode.trim().toUpperCase();
            if (!code) {
                this.erroresNuevoPadre.code = "El código es requerido";
                valid = false;
            }

            const desc = this.nuevoPadreDesc.trim();
            if (!desc) {
                this.erroresNuevoPadre.desc = "La descripción es requerida";
                valid = false;
            }

            if (!valid) return;

            if (this.padresEnTabla.some(p => p.code === code)) {
                this.$fun.alert("El inductor ya se encuentra agregado en la lista.", "warning");
                return;
            }

            this.padresEnTabla.push({
                code: code,
                desc: desc,
                cantActual: "0.000000",
                nuevaCant: this.formatTo6Decimals(this.cantLmat),
                artPorUnidCompra: this.formatTo6Decimals(this.artPorUnidCompra),
                cantPorPaquete: this.formatTo6Decimals(this.cantPorPaquete),
                estado: "Nuevo",
                seleccionado: true
            });

            this.filaActivaCode = code;
            this.guardarEstado();
            this.modalAgregarPadre = false;
        },
        // ===== MODAL CATÁLOGO =====
        abrirCatalogo() {
            this.busquedaCatalogo = "";
            this.limpiarSeleccionGrupo();
            this.modalCatalogo = true;
        },
        cerrarCatalogo() { this.modalCatalogo = false; },
        seleccionarInsumo(code) {
            this.seleccionarMaterial(code);
            this.cerrarCatalogo();
        },
        filtrarGruposCatalogo() {
            const q = this.busquedaGrupoCatalogo.trim().toLowerCase();
            if (!q) {
                this.sugerenciasGrupos = this.gruposInductores;
            } else {
                this.sugerenciasGrupos = this.gruposInductores.filter(g =>
                    String(g.cod).toLowerCase().includes(q) ||
                    g.nam.toLowerCase().includes(q)
                );
            }
            this.dropdownGrupoVisible = this.sugerenciasGrupos.length > 0;
        },
        mostrarDropdownGrupo() {
            this.filtrarGruposCatalogo();
        },
        scheduleOcultarDropdownGrupo() {
            setTimeout(() => { this.dropdownGrupoVisible = false; }, 200);
        },
        seleccionarGrupoCatalogo(g) {
            this.grupoCatalogoSeleccionado = g;
            this.busquedaGrupoCatalogo = g.nam;
            this.dropdownGrupoVisible = false;
            this.paginaCatalogo = 1;
        },
        limpiarSeleccionGrupo() {
            this.grupoCatalogoSeleccionado = null;
            this.busquedaGrupoCatalogo = "";
            this.dropdownGrupoVisible = false;
            this.paginaCatalogo = 1;
        },
        // ===== MODAL BOM =====
        verLmatComponentes() {
            if (!this.articuloSeleccionado) { this.$fun.alert("Seleccione un insumo primero.", "warning"); return; }
            this.abrirBom(this.articuloSeleccionado.code);
        },
        verBomPadre(code) { this.abrirBom(code); },
        abrirBom(code) {
            this.bomCode = code;

            const itemEncontrado = articulosData.find(item => item.CodigoArticuloPadre === code);
            if (itemEncontrado) {
                let inductores = [];
                if (itemEncontrado.InductoresJSON) {
                    try {
                        let rawStr = itemEncontrado.InductoresJSON;
                        if (typeof rawStr === "string") {
                            rawStr = rawStr.trim();
                            if (!rawStr.endsWith("]")) {
                                const lastBrace = rawStr.lastIndexOf("}");
                                if (lastBrace !== -1) {
                                    rawStr = rawStr.substring(0, lastBrace + 1) + "]";
                                }
                            }
                            inductores = JSON.parse(rawStr);
                        } else {
                            inductores = rawStr;
                        }
                    } catch (e) {
                        console.error("Error al parsear InductoresJSON:", e);
                    }
                }

                const listaMapeada = inductores.map(ind => ({
                    code: ind.CodigoInductor || "",
                    desc: ind.DescripcionInductor || "Sin descripción",
                    tipo: ind.GrupoInductor || "Insumo",
                    cant: ind.QuantityInductor || 0,
                    um: "UND"
                }));

                this.bomData = {
                    code: code,
                    desc: itemEncontrado.NombreArticuloPadre || itemEncontrado.DescripcionArticuloPadre || "Sin descripción",
                    lmat: listaMapeada
                };
            } else {
                const art = articulosMasterDB.find(a => a.code === code);
                if (art) {
                    this.bomData = {
                        code: art.code,
                        desc: art.desc,
                        lmat: art.lmat || []
                    };
                } else {
                    this.bomData = null;
                }
            }
            this.modalBom = true;
        },
        cerrarBom() { this.modalBom = false; },
        // ===== APLICAR CAMBIOS =====
        aplicarCambios() {
            if (!this.articuloSeleccionado) { this.$fun.alert("Seleccione una lista de materiales primero.", "warning"); return; }
            const seleccionados = this.padresEnTabla.filter(p => p.seleccionado);
            if (!seleccionados.length) { this.$fun.alert("Seleccione al menos un inductor.", "warning"); return; }

            // Validar que todos los seleccionados tengan valores válidos
            const invalidos = seleccionados.filter(p => 
                p.artPorUnidCompra === null || p.artPorUnidCompra === undefined || isNaN(Number(p.artPorUnidCompra)) || Number(p.artPorUnidCompra) < 0 ||
                p.cantPorPaquete === null || p.cantPorPaquete === undefined || isNaN(Number(p.cantPorPaquete)) || Number(p.cantPorPaquete) < 0
            );
            if (invalidos.length) {
                this.$fun.alert("Existen filas seleccionadas con valores de parámetros inválidos o menores que 0.", "warning");
                return;
            }

            const art = this.articuloSeleccionado;
            const ts = new Date().toISOString();
            const lines = [];
            lines.push(`<div class="log-line yellow">[${ts}] === INICIO OPERACIÓN MASIVA SAP B1 ===</div>`);
            lines.push(`<div class="log-line blue-l">[INFO] Lista de Materiales: ${art.code} - ${art.desc}</div>`);
            lines.push(`<div class="log-line blue-l">[INFO] Inductores seleccionados: ${seleccionados.length}</div>`);
            lines.push(`<div class="log-line">&nbsp;</div>`);
            seleccionados.forEach(p => {
                const payloadItems = { ItemsPerPurchaseUnit: p.artPorUnidCompra, PurchaseQtyPerPackUnit: p.cantPorPaquete };
                lines.push(`<div class="log-line green">PATCH /b1s/v1/Items('${p.code}')</div>`);
                lines.push(`<div class="log-line slate">${JSON.stringify(payloadItems, null, 2).replace(/\n/g, "<br>").replace(/ /g, "&nbsp;")}</div>`);
                lines.push(`<div class="log-line">&nbsp;</div>`);

                const payload = { ProductTreeLines: [{ ItemNo: p.code, Quantity: p.nuevaCant, Comment: `Actualizado masivamente desde herramienta externa ${ts}` }] };
                lines.push(`<div class="log-line green">PATCH /b1s/v1/ProductTrees('${art.code}')</div>`);
                lines.push(`<div class="log-line slate">${JSON.stringify(payload, null, 2).replace(/\n/g, "<br>").replace(/ /g, "&nbsp;")}</div>`);
                lines.push(`<div class="log-line">&nbsp;</div>`);
            });
            lines.push(`<div class="log-line yellow">[${new Date().toISOString()}] === OPERACIÓN COMPLETADA (SIMULADO) ===</div>`);
            this.logsHtml = lines.join("");
            this.modalLogs = true;
        },
        cerrarLogs() { this.modalLogs = false; },
    },
};
</script>

<style scoped>
/* ====== ROOT ====== */
.sap-bom-root {
    font-family: "Inter", "Segoe UI", sans-serif;
    background: #f1f5f9;
}

/* ====== HEADER ====== */
.sap-header {
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .05);
    padding: 10px 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.sap-header-inner {
    display: contents;
}

.sap-header-left {}



.sap-title {
    color: #0f172a;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
    margin: 0;
}

.sap-header-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* ====== BUTTONS ====== */
.btn-primary {
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s;
}

.btn-primary:hover {
    background: #1d4ed8;
}

.btn-secondary {
    background: #334155;
    color: #fff;
    border: none;
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s;
}

.btn-secondary:hover {
    background: #475569;
}

.btn-ghost {
    background: #f1f5f9;
    color: #475569;
    border: none;
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s;
}

.btn-ghost:hover {
    background: #e2e8f0;
}

.btn-outline {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s;
}

.btn-outline:hover {
    background: #dbeafe;
}

.btn-apply {
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 16px;
    padding: 12px 32px;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 8px 24px rgba(37, 99, 235, .35);
    transition: background .2s, box-shadow .2s;
}

.btn-apply:hover {
    background: #1d4ed8;
    box-shadow: 0 12px 32px rgba(37, 99, 235, .45);
}

.btn-sm-ghost {
    background: #f1f5f9;
    color: #475569;
    border: none;
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 11px;
    cursor: pointer;
    transition: background .2s;
}

.btn-sm-ghost:hover {
    background: #dbeafe;
    color: #1d4ed8;
}

.btn-delete {
    background: none;
    border: none;
    color: #f87171;
    font-size: 18px;
    cursor: pointer;
    transition: color .2s;
    line-height: 1;
}

.btn-delete:hover {
    color: #dc2626;
}

.btn-primary-sm {
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 4px 12px;
    font-size: 11px;
    cursor: pointer;
    transition: background .2s;
}

.btn-primary-sm:hover {
    background: #1d4ed8;
}

.btn-gray {
    background: #334155;
    color: #fff;
    border: none;
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 12px;
    cursor: pointer;
}

.btn-gray:hover {
    background: #475569;
}

.w-full {
    width: 100%;
}

/* ====== CONTAINER & LAYOUT ====== */
.sap-main {
    padding-top: 12px;
    /* padding: 12px 14px 20px; */
}

.grid-12 {
    display: grid;
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    gap: 12px;
    align-items: start;
    margin-bottom: 12px;
}

@media(max-width: 900px) {
    .grid-12 {
        grid-template-columns: 1fr;
    }
}

.sap-col-5,
.sap-col-7 {
    min-width: 0;
    width: 100%;
}

.sap-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
    border: 1px solid #f1f5f9;
    padding: 8px;
    box-sizing: border-box;
}



/* ====== STEP ====== */
.step-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}

.step-badge {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #2563eb;
    color: #fff;
    font-weight: 800;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.step-title {
    color: #1e293b;
    font-size: 15px;
    font-weight: 800;
    margin: 0;
}

/* ====== FIELDS ====== */
.field-group {
    margin-bottom: 16px;
    position: relative;
}

.field-label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 5px;
}

.field-input {
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 8px 12px;
    font-size: 13px;
    background: #f8fafc;
    outline: none;
    box-sizing: border-box;
    transition: border-color .2s, box-shadow .2s;
}

.field-input:disabled {
    background: #cbd5e1;
    color: #475569;
    cursor: not-allowed;
    border-color: #94a3b8;
}

.btn-clear-input {
    position: absolute;
    right: 8px;
    background: #ef4444;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s;
}

.btn-clear-input:hover {
    background: #dc2626;
}

.field-input:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(96, 165, 250, .2);
}

.field-readonly {
    cursor: not-allowed;
    color: #64748b;
}

.field-hint {
    font-size: 11px;
    color: #94a3b8;
    margin: 4px 0 0;
}

.text-right {
    text-align: right;
}

.mono {
    font-family: "Fira Mono", "Consolas", monospace;
}

.relative {
    position: relative;
}

/* ====== AUTOCOMPLETE ====== */
.autocomplete-dropdown {
    position: absolute;
    z-index: 100;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .12);
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    top: calc(100% + 2px);
    left: 0;
}

.autocomplete-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f8fafc;
}

.autocomplete-item:last-child {
    border-bottom: none;
}

.autocomplete-item:hover {
    background: #eff6ff;
}

.ac-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ac-code {
    font-weight: 700;
    color: #1e293b;
    font-size: 13px;
}

.ac-grupo {
    font-size: 11px;
    color: #94a3b8;
}

.ac-desc {
    font-size: 11px;
    color: #64748b;
    margin: 2px 0 0;
}

/* ====== FICHA ====== */
.sap-ficha-card {
    background: #f8fafc;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    padding: 10px 12px;
    margin-bottom: 12px;
}

.ficha-title {
    font-size: 10px;
    font-weight: 800;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: .8px;
    margin: 0 0 12px;
}

.ficha-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.ficha-item {
    text-align: center;
}

.ficha-label {
    font-size: 11px;
    color: #94a3b8;
    margin: 0 0 2px;
}

.ficha-value {
    font-size: 13px;
    font-weight: 700;
    color: #334155;
    margin: 0;
}

.ficha-value.blue {
    color: #2563eb;
}

/* ====== PARAMS GRID ====== */
.params-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

@media(max-width: 500px) {
    .params-grid {
        grid-template-columns: 1fr;
    }
}

/* ====== INFO BOX ====== */
.info-box {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 12px;
    padding: 10px 12px;
}

.info-text {
    font-size: 12px;
    color: #1d4ed8;
    margin: 0;
}

.label-um {
    color: #3b82f6;
}

/* ====== PASO 3 ====== */
.paso3-card {
    margin-top: 0;
}

.paso3-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

/* ====== TABLE ====== */
.table-wrapper {
    overflow-x: auto;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
}

.sap-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.sap-table.xs {
    font-size: 10px;
}

.table-head,
.sap-table thead tr.table-head:hover {
    background: #1e293b !important;
    color: #fff !important;
}

.sap-table thead tr:hover,
.sap-table thead tr:hover th {
    background: inherit !important;
}

.th-check {
    padding: 8px;
    text-align: center;
    width: 40px;
}

.th-left {
    padding: 8px;
    text-align: left;
    font-weight: 700;
}

.th-center {
    padding: 8px;
    text-align: center;
    font-weight: 700;
}

.th-right {
    padding: 8px;
    text-align: right;
    font-weight: 700;
}

.table-row {
    border-bottom: 1px solid #f1f5f9;
    transition: background .15s;
}

.table-row.row-selected {
    background: #f8fafc;
}

.table-row.row-active {
    background: #dbeafe !important;
    border-left: 3px solid #2563eb;
}

.table-row:hover {
    background: #eff6ff;
}

.table-row-hover {
    border-bottom: 1px solid #f8fafc;
    transition: background .15s;
}

.table-row-hover:hover {
    background: #eff6ff;
}

.td-empty {
    text-align: center;
    padding: 32px;
    color: #94a3b8;
    font-size: 13px;
}

.td-check {
    padding: 8px;
    text-align: center;
}

.td-mono {
    padding: 8px;
    font-family: "Fira Mono", monospace;
    font-weight: 700;
    color: #334155;
}

.td-text {
    padding: 8px;
    color: #475569;
}

.td-center {
    padding: 8px;
    text-align: center;
}

.td-right {
    padding: 8px;
    text-align: right;
}

.mono-sm {
    font-family: "Fira Mono", monospace;
    font-size: 13px;
}

.gray {
    color: #64748b;
}

.blue-bold {
    font-weight: 800;
    color: #2563eb;
}

.text-sm {
    font-size: 12px;
}

.badge-green {
    background: #dcfce7;
    color: #15803d;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
}

.badge-blue {
    background: #dbeafe;
    color: #1d4ed8;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
}

.badge-green-sm {
    background: #dcfce7;
    color: #15803d;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 6px;
}

.badge-gray-sm {
    background: #f1f5f9;
    color: #64748b;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 6px;
}

.badge-tipo {
    background: #eff6ff;
    color: #2563eb;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 6px;
}

.apply-bar {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
}

.sticky-head {
    position: sticky;
    top: 0;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

/* ====== MODALS ====== */
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, .5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}

.modal-box {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 24px 64px rgba(0, 0, 0, .2);
    width: 100%;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
}

.modal-xl {
    max-width: 1280px;
}

.modal-lg {
    max-width: 1000px;
}

.modal-md {
    max-width: 680px;
}

.modal-dark {
    background: #0f172a;
}

.modal-header-white {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #f1f5f9;
}

.modal-header-blue {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: #1e3a8a;
    border-radius: 16px 16px 0 0;
}

.modal-header-dark {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid #1e293b;
}

.modal-title-dark {
    font-size: 17px;
    font-weight: 800;
    color: #1e293b;
    margin: 0;
}

.modal-title-white {
    font-size: 17px;
    font-weight: 800;
    color: #fff;
    margin: 0;
}

.modal-title-green {
    font-size: 13px;
    font-weight: 800;
    color: #4ade80;
    font-family: monospace;
    margin: 0;
}

.modal-subtitle-dark {
    font-size: 11px;
    color: #94a3b8;
    margin: 4px 0 0;
}

.modal-subtitle-blue {
    font-size: 11px;
    color: #93c5fd;
    margin: 4px 0 0;
}

.modal-close-dark {
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
    color: #94a3b8;
    line-height: 1;
}

.modal-close-dark:hover {
    color: #1e293b;
}

.modal-close-white {
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
    color: rgba(255, 255, 255, .7);
    line-height: 1;
}

.modal-close-white:hover {
    color: #fff;
}

.modal-close-gray {
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
    color: #64748b;
    line-height: 1;
}

.modal-close-gray:hover {
    color: #fff;
}

.modal-search-bar {
    padding: 16px;
    border-bottom: 1px solid #f1f5f9;
}

.modal-scroll {
    overflow-y: auto;
    flex: 1;
}

.p-md {
    padding: 16px;
}

.bom-info-bar {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 16px;
    background: #eff6ff;
    border-bottom: 1px solid #bfdbfe;
}

@media(min-width: 640px) {
    .bom-info-bar {
        grid-template-columns: repeat(4, 1fr);
    }
}

.bom-info-item {
    text-align: center;
}

.bom-info-label {
    font-size: 11px;
    color: #93c5fd;
    margin: 0 0 2px;
}

.bom-info-value {
    font-size: 13px;
    font-weight: 800;
    color: #1e3a8a;
    margin: 0;
}

.bom-status-ok {
    font-size: 13px;
    font-weight: 800;
    color: #16a34a;
    margin: 0;
}

.bom-status-new {
    font-size: 13px;
    font-weight: 800;
    color: #d97706;
    margin: 0;
}

.bom-thead {
    background: #f1f5f9;
}

.modal-footer-light {
    padding: 12px 16px;
    background: #f8fafc;
    border-top: 1px solid #f1f5f9;
    font-size: 12px;
    color: #64748b;
    border-radius: 0 0 16px 16px;
}

.modal-md {
    max-width: 420px;
}

.modal-footer-white {
    padding: 12px 16px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    border-radius: 0 0 16px 16px;
    background: #ffffff;
}

.modal-footer-dark {
    padding: 12px 16px;
    border-top: 1px solid #1e293b;
    display: flex;
    justify-content: flex-end;
}

.consola-logs {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    font-family: "Fira Mono", "Consolas", monospace;
    font-size: 12px;
    line-height: 1.7;
    color: #86efac;
}
</style>

<style>
.consola-logs .log-line {
    display: block;
}

.consola-logs .yellow {
    color: #fbbf24;
}

.consola-logs .green {
    color: #4ade80;
}

.consola-logs .blue-l {
    color: #93c5fd;
}

.consola-logs .slate {
    color: #cbd5e1;
}
</style>
